(function () {
  'use strict';

  var CONFIG = {
    ctaLink: 'https://searchright.net/request/?utm_source=blog&utm_medium=banner&utm_campaign=bottom_cta',
    sideShowAt: 0.5,
  };

  // ── 배너 데이터 (3종) ─────────────────────────────────
  var BANNERS = [
    {
      variant: 'light',
      headline: '아직도 채용 공고에 지원 안 하는\n66%의 인재를 놓치고 계신가요?',
      subcopy: '서치라이트AI는 역량 메타데이터 기반 AI로 기존 플랫폼에서 검색되지 않는 핵심 인재를 발굴합니다.',
      ctaText: '무료 상담 신청하기',
      sideHeadline: '놓치고 있는 66%의 인재,\nAI로 찾아보세요',
      sideSubcopy: '기존 플랫폼에서 검색되지 않는 핵심 인재를 발굴합니다.',
      sideCtaText: '무료 상담 신청',
    },
    {
      variant: 'brand',
      headline: '검색되지 않는 인재,\nAI가 찾아드립니다',
      subcopy: '메시지 회신율 40%, 업계 평균의 3배. 포지션에 딱 맞는 후보자 리스트를 받아보세요.',
      ctaText: '우리 팀 채용, 상담받기',
      sideHeadline: '회신율 40%,\n업계 평균의 3배',
      sideSubcopy: '포지션에 딱 맞는 후보자 리스트를 받아보세요.',
      sideCtaText: '상담받기',
    },
    {
      variant: 'outlined',
      headline: '80개+ 기업이 선택한\nAI 인재 발굴 솔루션',
      subcopy: '헤드헌팅 대비 1/3 비용으로, 3배 더 높은 회신율. 지금 바로 경험해 보세요.',
      ctaText: '도입 문의하기',
      sideHeadline: '80개+ 기업이 선택한\nAI 인재 발굴',
      sideSubcopy: '헤드헌팅 대비 1/3 비용, 3배 높은 회신율.',
      sideCtaText: '도입 문의',
    },
  ];

  var STATS = [
    { value: '40%', label: '메시지 회신율' },
    { value: '80개+', label: '누적 고객사' },
    { value: '1/3', label: '헤드헌팅 대비 비용' },
  ];

  var ARROW = '<svg class="sr-banner__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
  var ARROW_S = '<svg class="sr-side__cta-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

  // ── 배너 HTML ─────────────────────────────────────────
  function createBannerHTML(data, placement) {
    var link = CONFIG.ctaLink + '&utm_content=' + placement;
    var h = data.headline.replace(/\n/g, '<br>');

    var st = STATS.map(function (s, i) {
      var d = i < STATS.length - 1 ? '<div class="sr-banner__divider"></div>' : '';
      return '<div class="sr-banner__stat"><span class="sr-banner__stat-value">' + s.value + '</span><span class="sr-banner__stat-label">' + s.label + '</span></div>' + d;
    }).join('');

    return '<div class="sr-banner sr-banner--' + data.variant + '" data-sr-placement="' + placement + '">' +
      '<div class="sr-banner__content"><h2 class="sr-banner__headline">' + h + '</h2>' +
      '<p class="sr-banner__subcopy">' + data.subcopy + '</p></div>' +
      '<div class="sr-banner__stats">' + st + '</div>' +
      '<a href="' + link + '" class="sr-banner__cta" target="_blank" rel="noopener">' + data.ctaText + ARROW + '</a></div>';
  }

  // ── 사이드 배너 HTML ──────────────────────────────────
  function createSideHTML(data) {
    var link = CONFIG.ctaLink + '&utm_content=side';
    var h = data.sideHeadline.replace(/\n/g, '<br>');

    return '<div class="sr-side" id="sr-side-banner"><div class="sr-side__card">' +
      '<button class="sr-side__close" id="sr-side-close" aria-label="닫기"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' +
      '<span class="sr-side__label">서치라이트AI</span>' +
      '<h3 class="sr-side__headline">' + h + '</h3>' +
      '<p class="sr-side__subcopy">' + data.sideSubcopy + '</p>' +
      '<a href="' + link + '" class="sr-side__cta" target="_blank" rel="noopener">' + data.sideCtaText + ARROW_S + '</a>' +
      '</div></div>';
  }

  // ── 랜덤 셔플 ────────────────────────────────────────
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  // ── Intersection Observer: 페이드인 ───────────────────
  function observeAll() {
    var banners = document.querySelectorAll('.sr-banner');
    if (!banners.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < banners.length; i++) banners[i].classList.add('sr-visible');
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sr-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.15 });

    for (var i = 0; i < banners.length; i++) obs.observe(banners[i]);
  }

  // ── 사이드 배너: 스크롤 트리거 ────────────────────────
  function initSideBanner() {
    var sideEl = document.getElementById('sr-side-banner');
    var closeBtn = document.getElementById('sr-side-close');
    if (!sideEl || !closeBtn) return;

    if (sessionStorage.getItem('sr-side-dismissed')) return;

    var shown = false;
    var dismissed = false;

    function onScroll() {
      if (dismissed) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = docHeight > 0 ? scrollTop / docHeight : 0;

      if (!shown && progress >= CONFIG.sideShowAt) {
        sideEl.classList.add('sr-side--visible');
        shown = true;
      }
    }

    closeBtn.addEventListener('click', function () {
      dismissed = true;
      sideEl.classList.remove('sr-side--visible');
      sideEl.classList.add('sr-side--hiding');
      sessionStorage.setItem('sr-side-dismissed', '1');
      window.removeEventListener('scroll', onScroll);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── 포스트 페이지 ─────────────────────────────────────
  function initPost() {
    var content = document.querySelector('.gh-content');
    if (!content) return false;

    var order = shuffle([0, 1, 2]);

    // 하단 배너: .gh-content 직후
    content.insertAdjacentHTML('afterend', createBannerHTML(BANNERS[order[0]], 'bottom'));

    // 사이드 배너
    document.body.insertAdjacentHTML('beforeend', createSideHTML(BANNERS[order[1]]));
    initSideBanner();

    return true;
  }

  // ── 홈(피드) 페이지 ───────────────────────────────────
  function initHome() {
    var feed = document.querySelector('.post-feed');
    if (!feed) return false;

    var order = shuffle([0, 1, 2]);

    // 하단 배너: .post-feed 뒤 (.inner 안에서 폭 자동 적용)
    feed.insertAdjacentHTML('afterend', createBannerHTML(BANNERS[order[0]], 'feed-bottom'));

    return true;
  }

  // ── 메인 ──────────────────────────────────────────────
  function init() {
    initPost() || initHome();
    observeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
